// extracted by mini-css-extract-plugin
export default {"checkoutPageContainer":"CheckoutPage_checkoutPageContainer__xLf4F","checkoutContainer":"CheckoutPage_checkoutContainer__uKr-6"};